// FeaturesSection.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaClock, FaCar, FaRupeeSign } from 'react-icons/fa';
import './FeaturesSection.css';

const features = [
  {
    icon: <FaClock size={28} />,
    title: '24×7 Service',
    desc: 'Focusing on holistic recovery and self-healing. Our center combines advanced medical team.',
    color: 'primary'
  },
  {
    icon: <FaCar size={28} />,
    title: 'Pick-up Service',
    desc: 'We are committed to helping our clients for complete liberation from their afflictions.',
    color: 'success'
  },
  {
    icon: <FaRupeeSign size={28} />,
    title: 'Affordable Service',
    desc: 'We focus on sustainable recovery strategies using both traditional and modern methods.',
    color: 'danger'
  }
];

const FeaturesSection = () => (
  <section className="features-section py-5 bg-light">
    <Container>
      {/* <h2 className="text-center mb-5 fw-bold">Our Key Features</h2> */}
      <Row className="g-4" data-aos="fade-up">
        {features.map((feature, index) => (
          <Col md={4} key={index}>
            <div className="feature-box p-4 rounded-4 shadow-sm bg-white h-100 hover-effect">
              <div className={`icon-circle bg-${feature.color} text-white mb-3 mx-auto`}>
                {feature.icon}
              </div>
              <h5 className="fw-semibold">{feature.title}</h5>
              <p className="text-muted">{feature.desc}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default FeaturesSection;
